/* eslint-disable */
import React from "react";
import { Link } from "react-router-dom";

const QuestionModal = () => {
  return (
    <>
      <div className="question_modal_bx">
        <div
          className="modal fade"
          id="question_success_modal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div className="sucess_question_icon">
                  <span className="material-icons-outlined">task_alt</span>
                </div>
                <div className="question_success_hdng">
                  <h2>Your query has reached us successfully</h2>
                  <h5>Soon we will send you a mail be ready</h5>
                </div>
                <div className="question_closeBtn">
                  <Link
                    to="#"
                    data-bs-dismiss="modal"
                    className="basic_btn ylw_btn"
                  >
                    Close
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuestionModal;
